import React from 'react';
import ComparisonTable from '../components/ComparisonTable';
import StepPricingTool from '../components/StepPricingTool';
import { usePageTitle } from '../hooks/usePageTitle';
import GlyphSvg from '../components/Glyphs';

export default function Pricing() {
  usePageTitle({
    title: 'Pricing & Plans',
    description: 'Choose the perfect plan for your avatar generation needs. Affordable pricing with professional results.',
    image: '/img/pricing-hero.jpg'
  });

  return (
    <>
      <div id="pricing-steps" style={{ width: '100vw', minHeight: '100vh', margin: 0, padding: 0, background: 'var(--c5, #222)' }}>
        <StepPricingTool />
      </div>
      
      <ComparisonTable />
    </>
  );
}
